/* unplugin-vue-components disabled */import { render } from "./sources-modal.vue?vue&type=template&id=0753ea8a&scoped=true"
import script from "./sources-modal.vue?vue&type=script&lang=js"
export * from "./sources-modal.vue?vue&type=script&lang=js"

import "./sources-modal.vue?vue&type=style&index=0&id=0753ea8a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0753ea8a"],['__file',"src/components/sources-v2/sources-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0753ea8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0753ea8a', __exports__)) {
    api.reload('0753ea8a', __exports__)
  }
  
  module.hot.accept("./sources-modal.vue?vue&type=template&id=0753ea8a&scoped=true", () => {
    api.rerender('0753ea8a', render)
  })

}


export default __exports__